import { IRoomsActionCreator, IRoomsActionTypes } from "models/IRoomsState";

const initialState: any = {
  rooms_list: {},
};

const reducer = (state = initialState, { type, payload }: IRoomsActionCreator) => {
  switch (type) {
    case IRoomsActionTypes.FETCH_ROOMS_REQUEST:
      return {
        ...state,
        rooms_list: {},
      };

    case IRoomsActionTypes.FETCH_ROOMS_SUCCESS:
      return {
        ...state,
        rooms_list: { ...payload },
      };

    case IRoomsActionTypes.FETCH_ROOMS_FAILURE:
      return {
        ...state,
        rooms_list: {},
      };

    default:
      return state;
  }
};

export default reducer;